import { TextInput } from "react-admin";
import MuiDatePickerInput from "../../common/MuiDatePickerInput";

const promotionFilterList = [
  <TextInput source="name" alwaysOn resettable />,
  <MuiDatePickerInput source="start_date" alwaysOn maxDateSource="end_date" />,
  <MuiDatePickerInput source="end_date" alwaysOn minDateSource="start_date" />,
];

export default promotionFilterList;
